<template>

    <div class="overlay" :class="{ 'overlay-dark' : isDark,'overlay-light' : !isDark }" 
                :style="styleTop" v-bind:key="counter">
    </div>
    <div class="overlay" :class="{ 'overlay-dark' : isDark,'overlay-light' : !isDark }" 
                :style="styleLeft" v-bind:key="counter">
    </div>
    <div class="overlay" :class="{ 'overlay-dark' : isDark,'overlay-light' : !isDark }" 
                :style="styleRight" v-bind:key="counter">
    </div>
    <div class="overlay" :class="{ 'overlay-dark' : isDark,'overlay-light' : !isDark }" 
                :style="styleBottom" v-bind:key="counter">
    </div>

    <div class="blurb" :style="styleBlurb" v-bind:key="counter">
      <div class="blurb-title" v-html="blurbTitle"></div>
      <div class="blurb-text" :style="{ height: (blurbHeight-100) + 'px' }" v-html="blurbText"></div>
      <div class="btn-row">
        <ion-button v-if="!nextButtonDisabled" id="next_button" @click="clickNext()">{{ t("Next") }}</ion-button>
        <ion-button id="done_button" @click="clickDone()" >{{ t("Done") }}</ion-button>

      </div>
    </div>
</template>

<script setup>

import { IonItem, IonList, IonButton, IonRange,IonPage, IonContent, modalController } from '@ionic/vue';

import { computed } from "@vue/reactivity"
import { ref } from 'vue'
import { watch } from "vue";
import { useGetData } from '@/composables/getData.js'
import { useConnectionStore } from '@/stores/connectionStore';
import { useWindowSizeStore } from '@/stores/windowSizeStore';
import { availableWidthHeight, calculateChessBoardRect, isScreenPortraitOrientation } from '@/composables/screenSize'
import { t } from "@/composables/translateText.js";

const emit = defineEmits(['tour-done'])

const props = defineProps({
  tour : {
    type : Object,
    default : null
  },
  tourTrigger : {
    type : Number,
    default : 0
  },
  translate : {
    type : Boolean,
    default : false
  }
})

const windowSizeStore = useWindowSizeStore()

const connectionStore = useConnectionStore()
const isDark = ref(connectionStore.getDarkmode != "light")

const counter = ref(0)
const tourTrigger = computed({ get() { return props.tourTrigger }})
const tour = computed({ get() { return props.tour }})

const blurbHeight = 260
const blurbWidth = 350
const nextButtonDisabled = ref(true)

const toolbarHeight = 50

const styleBlurb = ref({
    top : "0px",
    left : "0px",
    width: "0px",
    height : "0px"
  })

const styleTop = ref({
    top : "0px",
    left : "0px",
    width: "0px",
    height : "0px",
  })

  const styleLeft = ref({
    top : "0px",
    left : "0px",
    width: "0px",
    height : "0px",
  })

  const styleRight = ref({
    top : "0px",
    left : "0px",
    width: "0px",
    height : "0px",
  })

  const styleBottom = ref({
    top : "0px",
    left : "0px",
    width: "0px",
    height : "0px",  
  })

  var currentIndex = 0
  const blurbTitle = ref("")
  const blurbText = ref("")
  
  buildStyles()

watch(tourTrigger, (newVal,oldVal) => {
  //console.log("*********************************** change",newVal)
  currentIndex = 0

  const tourId = (props.tour.id != undefined) ? props.tour.id : "not set"
  readTour(tourId)
  
  buildStyles()
})

function buildStyles() {

  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })

  var rect = {top : 0, left : 0, height : 0, width : 0}
  const availableSpace = availableWidthHeight()
  const isPortrait = isScreenPortraitOrientation(availableSpace)
  windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                      height : windowSizeStore.getWindowSize['height'] }

  //console.log("TOUR count ",props.tour.elements.length)

  if (currentIndex >= props.tour.elements.length)
    return
  nextButtonDisabled.value = (currentIndex >= props.tour.elements.length - 1)

  // if no id, center on screen
  if (props.tour.elements[currentIndex].id == "") {
    rect.top = (isPortrait) ? (windowSizeRef.value.height/2 + blurbHeight/2) : windowSizeRef.value.height/2 - blurbHeight/2
    rect.left =  windowSizeRef.value.width/2
    rect.height = 0
    rect.width = 0
  }
  else {
    const element = document.getElementById(props.tour.elements[currentIndex].id)
    if (element == null)
      return
    rect = element.getBoundingClientRect()
  }
  //console.log("rect",rect)

  styleTop.value.top = 0 + "px"
  styleTop.value.left = 0 + "px"
  styleTop.value.width = windowSizeRef.value.width + "px"
  styleTop.value.height = rect.top + "px"

  styleBottom.value.top = (rect.top + rect.height) + "px"
  styleBottom.value.left = 0 + "px"
  styleBottom.value.width = windowSizeRef.value.width + "px"
  styleBottom.value.height = (windowSizeRef.value.height - (rect.top + rect.height)) + "px"

  styleLeft.value.top = rect.top + "px"
  styleLeft.value.left = 0 + "px"
  styleLeft.value.width = rect.left + "px"
  styleLeft.value.height = rect.height + "px"

  styleRight.value.top = rect.top + "px"
  styleRight.value.left = (rect.left + rect.width) + "px"
  styleRight.value.width = (windowSizeRef.value.width - (rect.left + rect.width)) + "px"
  styleRight.value.height = rect.height + "px"

  blurbTitle.value = (props.translate) ? t(props.tour.elements[currentIndex].title) : props.tour.elements[currentIndex].title
  blurbText.value = (props.translate) ? t(props.tour.elements[currentIndex].text) : props.tour.elements[currentIndex].text

  // if "the_board", center on the board
  if (props.tour.elements[currentIndex].id == "the_board") {
    styleBlurb.value.top = (rect.top + rect.height/2 - blurbHeight/2)  + "px"
    styleBlurb.value.left = (rect.left + rect.width/2 - blurbWidth/2)  + "px"
  }
  else
  if (isPortrait || rect.left <= availableSpace.leftRightIndent) {
    const desiredTop = (rect.top - blurbHeight - 20)
    const desiredLeft = rect.left + (rect.width - blurbWidth)/2
    styleBlurb.value.top = ((desiredTop >= 0) ? desiredTop : 0)  + "px"

    styleBlurb.value.left = ((desiredLeft >= 0) ? desiredLeft : 0)  + "px"
  }
  else {
    const desiredLeft = (rect.left - blurbWidth - 20)

    // keep bottom from going off bottom of screen
    const useTop = (rect.top + blurbHeight <= windowSizeRef.value.height - toolbarHeight) ? rect.top : 
              windowSizeRef.value.height - blurbHeight - toolbarHeight
    styleBlurb.value.top = useTop + "px"
    styleBlurb.value.left = ((desiredLeft >= 0) ? desiredLeft : 0)  + "px"

  }
  styleBlurb.value.height = blurbHeight + "px"
  styleBlurb.value.width = blurbWidth + "px"

}

function clickNext() {
  currentIndex++;
  buildStyles()
}

function clickDone() {
  emit("tour-done")

}

 const openErrorModal = async (programName,errorMessage) => {
    const modal = await modalController.create({
      component: ModalErrorMessage,
      componentProps: {
        type : "commError",
        program : programName ,
        errorMessage : errorMessage
      }
    });

    modal.present();

    const { data, role } = await modal.onWillDismiss();
  };

function processTourJsonResponse(json) {
  if (json.hasOwnProperty('error')) {
    openErrorModal(json['programRun'],json['error'])
    return;
  }
}

// just register that the user did the tour
function readTour(tourName) {
  var formData = {
    t : tourName
  }
  useGetData("chessvis_read_tour.php", formData, processTourJsonResponse)
}

</script>

<style scoped>

.btn-row {
  float: left;
  position : absolute;
  bottom : 0px;
  display: block;

}

.btn-one {
  margin-left : 10px;
  margin-right : 10px;
}
.blurb {
  position: fixed;
  z-index: 10000;

  padding : 10px;
  text-align : "center";
  background-color : white;
  color : black;
  border : solid 5px lightgrey;
}

.overlay-light {
  background-color: black;
  color : white;
}

.overlay-dark {
  background-color: white;
  color : black;
}

.overlay {
  position : fixed;
  opacity: 0.5;
  font-size : 32px;
  z-index : 2001;
  pointer-events:none;
}

.blurb-title {
  text-align: center;
  color : blue;
  font-weight: bold;
  padding-bottom : 10px;
}

.blurb-text {
  overflow-y: scroll;
}

</style>